<template>
  <div>
    <pbas-data-table
      :exporters="$exporters"
      ref="table"
      :dataProvider="provider"
      fileNamePrefix="employersContributionsHistory"
      :identifier="`employer${employerId}contributionsHistory`"
      @error="error = $event"
      :showSelect="false"
      :rowActions="rowActions"
      :canExpand="(item) => true"
      :showExpand="true"
      :generateProviderForExpanded="(item) => generateProvider(item)"
      :expandedSortBy="'EffectiveDate'"
      :expandedSortDescending="true"
      :expandedRowActions="expandedRowActions"
    ></pbas-data-table>
    <v-dialog
      scrollable
      v-model="notImplementedDialog"
      persistent
      max-width="400"
    >
      <v-card>
        <v-card-title>
          {{ $t("views.balanceview.not_implemented") }}
        </v-card-title>
        <v-card-actions>
          <v-btn text @click="notImplementedDialog = false">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <details-dialog
      v-if="selected"
      :model="detailsDialog"
      :item="selected"
      @close="detailsDialog = false"
      :type="selected.Reason"
      :id="selected.Id"
      :hasLocations="hasLocations"
      :employerId="employerId"
      :storeId="storeId"
    />
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import { ODataProvider } from "pbas-vue-components";
import getHeaders from "@/headers/EmployerContributionsHistory";
import DetailsDialog from "./DetailsDialog.vue";
export default {
  props: ["employerId", "hasLocations"],
  components: {
    ErrorHandler,
    DetailsDialog,
  },
  data() {
    return {
      error: null,
      provider: undefined,
      notImplementedDialog: false,
      rowActions: [
        {
          name: "reconcile",
          icon: "beach_access",
          title: "components.employers.employers_contributions.reconcile",
          handler: (item) => {
            this.notImplementedDialog = true;
          },
        },
        {
          name: "getUploadFile",
          icon: "remove_done",
          title: "components.employers.employers_contributions.get_upload_file",
          handler: (item) => {
            this.notImplementedDialog = true;
          },
        },
        {
          name: "viewPaymentInfo",
          icon: "deck",
          title:
            "components.employers.employers_contributions.view_payment_info",
          handler: (item) => {
            this.notImplementedDialog = true;
          },
        },
      ],
      expandedRowActions: [
        {
          name: "details",
          icon: "visibility",
          title: "components.membersmanagementtable.details",
          handler: (item) => this.detailsHandler(item),
          visible: (item) =>
            item.Reason === "Payment" ||
            item.Reason === "HoursReport" ||
            item.Reason === "Expense" ||
            item.Reason === "HoursImport",
        },
      ],
      detailsDialog: false,
      selected: null,
      storeId: null,
      histories: {}
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["planOptions", "options", "planIdentity"]),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    async loadPlanData() {
      let url =
        "plans/" +
        this.selectedPlan.Id +
        "/employers/" +
        this.employerId +
        "/contributions/history";
      if (this.hasLocations) {
        url =
          "plans/" +
          this.selectedPlan.Id +
          "/employers/" +
          this.employerId +
          "/stores/contributions/history";
      }
      let headers = getHeaders(
        false,
        this.hasLocations,
        this.planIdentity.Current.HasContributions,
        this.options.Enums
      );
      console.log(
        "##########################",
        headers,
        this.hasLocations,
        this.planIdentity.Current.HasContributions
      );
      this.provider = new ODataProvider(this.$axiosHttp, url, headers);
    },
    getDataAsync() {
      this.$refs.table.getDataAsync();
    },
    generateProvider(item) {
      let url =
        "plans/" +
        this.selectedPlan.Id +
        "/employers/" +
        this.employerId +
        "/contributions/history/terms/" +
        item.Term.Id;
      if (this.hasLocations) {
        let storeId = item.Store.Id;
        url =
          "plans/" +
          this.selectedPlan.Id +
          "/employers/" +
          this.employerId +
          "/contributions/history/terms/" +
          item.Term.Id +
          "/location/" +
          storeId;
      }
      let p = new ODataProvider(
        this.$axiosHttp,
        url,
        getHeaders(
          true,
          this.hasLocations,
          this.planIdentity.Current.HasContributions,
          this.options.Enums
        )
      );
      return p;
    },
    detailsHandler(item) {
      this.selected = item;
      if (this.hasLocations) {
        this.storeId = item.Store.Id;
      }
      this.detailsDialog = true;
    },
  },
};
</script>
